import moment from "moment";
import { useEffect, useState } from "react";

export default function RelativeDate(props: { date: string | undefined }) {
  const [dateString, refreshDate] = useState(moment(props.date).fromNow());
  useEffect(() => {
    const date = moment(props.date);
    const handle = setInterval(() => refreshDate(date.fromNow()), 60000);
    return () => clearInterval(handle);
  }, [props.date]);

  return <>{props.date ? dateString : "never"}</>;
}
